module.exports = __webpack_public_path__ + "img/user_img.8bf91f2d.jpg";